import { Spinner } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks';
import { consumeRedirect } from '../utils/redirectAfterLogin';

/**
 * Aterrissagem do SSO (PKCE server-side). O backend já trocou o code, emitiu os
 * cookies e redirecionou pra cá com ?success=1 — ou para /login?error em falha.
 * Aqui só confirmamos a sessão via /me e seguimos para o destino salvo.
 */
export function AzureCallback() {
  const [params] = useSearchParams();
  const { isAuthenticated, isLoading } = useAuth();
  const { t } = useTranslation('auth');

  if (params.get('success') !== '1') {
    return <Navigate to="/login?error=auth_failed" replace />;
  }
  if (isLoading) return <Spinner layout="fullPage" label={t('azureCallbackPending')} />;
  if (isAuthenticated) return <Navigate to={consumeRedirect() ?? '/'} replace />;
  return <Navigate to="/login?error=auth_failed" replace />;
}
